import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'lib-metadatalistdetails',
  templateUrl: './metadatalistdetails.component.html',
  styleUrls: ['./metadatalistdetails.component.css']
})
export class MetadatalistdetailsComponent implements OnInit {
  selectableSetting = { mode: 'single', checkboxOnly: false };
  dotnet = 'dotnet';
  java = 'java';
  detailSkip = 0;
  detailView: GridDataResult;
  pageSize = 5;
  @Input() isMavenEnable: boolean;
  @Input() public mdItem: any;
  @Output() selectedPkgChanged = new EventEmitter<any>();
  dataItem: any[] = [];
  @Input() public codelanguage: string;
  constructor() { }

  ngOnInit() {
    if (this.mdItem && this.mdItem.repoPkg) {
      this.dataItem = this.mdItem.repoPkg;
      this.detailView = {
        data: this.dataItem.slice(this.detailSkip, this.detailSkip + this.pageSize),
        total: this.dataItem.length
      };
    }
  }

  detailPageChange({ skip, take }: PageChangeEvent) {
    this.detailSkip = skip;
    this.detailView = {
      data: this.dataItem.slice(this.detailSkip, this.detailSkip + take),
      total: this.dataItem.length
    };
  }

  onSelectedPkgChanged(event) {
    this.mdItem.selectedPkg = event.selectedRows[0].dataItem;
    this.selectedPkgChanged.emit(this.mdItem);
  }
}
